module.exports = __webpack_public_path__ + "static/media/img-card (7).9cbb33d1.jpg";